module.exports = __webpack_public_path__ + "img/flow_02.344fb16e.png";